import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import {
    clearAdminToken,
    getAdminToken,
    setAdminToken,
    verifyAdminToken,
} from "../../utils/adminAuth";

// 受保护路由的统一守卫：校验隐蔽后台 JWT，未登录跳首页。
// 同时捕获登录回跳带来的 ?k=<token>（与旧 Admin 页逻辑一致），
// 使任意受保护页面被直接访问时也能完成 token 落地。
function RequireAdmin({ children }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [status, setStatus] = useState("checking");

    useEffect(() => {
        let active = true;

        const incomingToken = searchParams.get("k");
        if (incomingToken) {
            setAdminToken(incomingToken);
            const next = new URLSearchParams(searchParams);
            next.delete("k");
            setSearchParams(next, { replace: true });
        }

        (async () => {
            const token = incomingToken || getAdminToken();
            const ok = await verifyAdminToken(token);
            if (!active) {
                return;
            }
            if (ok) {
                setStatus("ok");
            } else {
                clearAdminToken();
                navigate("/", { replace: true });
            }
        })();

        return () => {
            active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (status !== "ok") {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    return children;
}

export default RequireAdmin;
